import { colors } from '@frontend/constants';
import { Icon, XStack } from '@frontend/web-react';
import { useEffect, useRef, useState } from 'react';

const SIDE_LENGTH = 56;
const STROKE_WIDTH = 6;
const RADIUS = (SIDE_LENGTH - STROKE_WIDTH) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export const CreditPaymentLoading = () => {
  const [progress, setProgress] = useState(0);
  const requestRef = useRef<number>(undefined);
  const startRef = useRef<MaybeNull<number>>(null);

  useEffect(() => {
    const duration = 1200; // ms for a full loop

    const animate = (timestamp: number) => {
      if (startRef.current === null) {
        // eslint-disable-next-line fp/no-mutation
        startRef.current = timestamp;
      }
      const elapsed = (timestamp - startRef.current) % duration;
      setProgress(elapsed / duration);
      // eslint-disable-next-line fp/no-mutation
      requestRef.current = requestAnimationFrame(animate);
    };

    // eslint-disable-next-line fp/no-mutation
    requestRef.current = requestAnimationFrame(animate);
    return () => {
      if (requestRef.current) {
        cancelAnimationFrame(requestRef.current);
      }
      // eslint-disable-next-line fp/no-mutation
      startRef.current = null;
    };
  }, []);

  const strokeDashoffset = CIRCUMFERENCE * (1 - progress);

  return (
    <XStack className="relative items-center justify-center size-xxxl">
      <svg height={SIDE_LENGTH} width={SIDE_LENGTH}>
        <circle
          cx={SIDE_LENGTH / 2}
          cy={SIDE_LENGTH / 2}
          fill="none"
          r={RADIUS}
          stroke={colors.neutral[300]}
          strokeWidth={STROKE_WIDTH}
        />
        <circle
          cx={SIDE_LENGTH / 2}
          cy={SIDE_LENGTH / 2}
          fill="none"
          r={RADIUS}
          stroke={colors.teal[300]}
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          strokeWidth={STROKE_WIDTH}
          transform={`rotate(-90 ${SIDE_LENGTH / 2} ${SIDE_LENGTH / 2})`}
        />
      </svg>
      <span className="absolute">
        <Icon color="primary" name="IconCash" size="xl" />
      </span>
    </XStack>
  );
};
